import React,{useState,useEffect} from 'react';
import './Home.css';
import car1 from'./Images/car1.png';
import car2 from './Images/Cover1.png';
import car3 from './Images/car2.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { FaCheck } from "react-icons/fa";
import { faStar } from '@fortawesome/free-solid-svg-icons'; 
import General from './Images/BDC_1.jpg';
import Cosmetic from './Images/BDC_2.jpg'
import Surgery from './Images/BDC_3.jpg'
import test1 from './Images/test2.png'
import test2 from './Images/test.png'
import test3 from './Images/test3.png'
// import dentalImage from './Images/young-man-happy-surprised-expression-dentist-clinic.jpg';
// import { FaTags} from 'react-icons/fa'; 
import dental1 from './Images/v1.png';
import dental2 from './Images/IMG20240913134831.jpg';
import dental3 from'./Images/IMG_20231201_174221.jpg';
import dental4 from './Images/dental2.png'
import {  FaCoffee, FaChild, FaClock,FaRegCheckCircle,FaTv,FaCalendarCheck,FaTag,FaCreditCard,  FaMedkit,  } from 'react-icons/fa';
import sec from './Images/dental2.png'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [quoteIndex, setQuoteIndex] = useState(0);
  const images = [
  car1,car2,car3
  ];
  const [showMore, setShowMore] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Check the screen size on mount and whenever the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    // Initialize screen size state
    handleResize();

    // Event listener for resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleReadMoreClick = () => {
    setShowMore(!showMore);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval); // Cleanup on unmount
  }, [images.length]);


  // const goToPrevious = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  // };

  // const goToNext = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  // };
  // const testimonials = [
  //   {
  //     name: "Meenal Sankhla ",
  //     message: "I am happy with my tooth aligners treatment! The entire process was seamless, from the initial consultation to the final result. Dr Tushita is professional, and genuinely invested in achieving perfection. She is friendly, accommodating, and always available to answer questions.  My aligners were custom-made to fit my unique needs, and the results have exceeded my expectations. My smile has never looked better I highly recommend Dr Tushita to anyone seeking top-notch orthodontic care.",
  //   },
  //   {
  //     name: "Shruthi Pandula",
  //     message: "I recently made a visit to Bombay Dental Company and my experience was so fab! I wanted to make an appointment with an orthodontist and get my Invisalign, something that I've been wanting to do for a while now, heard great things about it.  One can tell she's highly seasoned in what she does, I did not feel any discomfort whatsoever.  Lovely calming atmosphere. And also Invisalign is hella affordable, did NOT know. Overall, highly recommend Invisalign by Dr. Tushita.",
  //   },
  //   {
  //     name: "Nidhi Sharma",
  //     message: "A Since I fixed my wedding date i've been looking for a good dentist in mumbai to fix my crooked teeth. My friend referred me to Dr Tushita Singh and I'm deeply impressed by her professional services, she asked me for my deadline and her follow up during our limited time was impeccable. I have referred her to 2 more friends since then, and very happy to say that my smile in the wedding photos were praised by one and all. Thank you Dr Tushita for giving my smile a new lease of life.",
  //   },
  //   {
  //     name: "Rahul",
  //     message: "It has been a great experience for me so far to have my treatment here.Dr. Tushita is very professional and proactive. She had explained to me everything about my teeth situation and suggested what will be the best procedure.The best thing here is that they respect the time of the patient  Overall I would say I had a very satisfying experience.",
  //   },
  //   {
  //     name: "Abhishek Kumar.",
  //     message: "Doctor friendliness Explanation of the health issue Treatment satisfaction Value for money!Dr. Tushita is a professional doctor who always advised the right thing to do. I went for root canal and was satisfied with the way I was explained about the problem and the solution. She ensured that all the necessary steps and precautions are taken care of. ",
  //   },
  //   {
  //      name:"    Kalpana Mehta ",
  //      message:"I would recommend bombay dental company to all those looking for a friendly and genuine doctor for their kids with a play area in the clinic and very fun and casual interiors that both my daughter and I enjoy. I usually lounge on the recliners in the waiting area, have a fresh cup of coffee and enjoy some snacks while reading a magazine while my daughter finishes her monthly appointment. "
  //   },
  // ];
  const services = [
    {
      title: "Problems we treat	",
      description: "Everything you expect and then some. Cleanings, fillings, and x-rays are just the beginning.",
      imgSrc: General, 
      buttonText: "ABOUT PROBLEMS WE TREAT",
      link: "/problem",
    },
    {
      title: "Orthodontics		",
      description: "Discover your 'wow!' factor. Invisalign, veneers, and in-office or take-home teeth whitening.",
      imgSrc: Cosmetic, // Replace with actual image path
      buttonText: "ABOUT ORTHODONTICS",
      link: "/braces",
    },
    {
      title: "Surgical",
      description: "We can fix anything. Our dentists repair damaged or lost teeth with cutting-edge implants.",
      imgSrc: Surgery, // Replace with actual image path
      buttonText: "ABOUT SURGERY",
      link: "/surgical",
    }
  ];
  
  const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock  size={40} />, label: " Time Management  " },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const quotes = [
    {
      text: "It has been a great experience for me so far to have my treatment here.Dr. Tushita is very professional and proactive.",
      author: "Rahul",
      // role: "Writer",
      image: test1,
    },
    {
      text: "I recently made a visit to Bombay Dental Company and my experience was so fab! I heard great things about it.",
      author: "Shruti Pandula",
      // role: "Writer",
      image: test3,
    },
   
    {
      text: "Dr. Tushita is a professional doctor who always advised the right thing to do. I went for root canal and was satisfied with the way I was explained about the problem and the solution.",
      author: "Abhishek Kumar",
      // role: "Writer",
      image: test2,
    }
  ];

  const nextQuote = () => {
    setQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
  };

  const prevQuote = () => {
    setQuoteIndex((prevIndex) => (prevIndex - 1 + quotes.length) % quotes.length);
  };

  const { text, author, role, image } = quotes[quoteIndex];

  useEffect(() => {
    const interval = setInterval(() => {
      nextQuote();
    }, 2000);
    return () => clearInterval(interval);
  }, [currentIndex]);

      const whatsAppLink = "https://wa.me/+918882672980?text=";
  
  return (
    <>
      <div className="home">
        <div className="carousel">
          {/* <button onClick={goToPrevious} className="carousel-button left">◀</button> */}
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Slide ${index + 1}`}
                className="carousel-image"
              />
            ))}
          </div>
          {/* <button onClick={goToNext} className="carousel-button right">▶</button> */}

          <div className="content1">
            <div className="text-section">
              <p className="trusted-text">
                <mark className="domark">TRUSTED WORLI, MUMBAI DENTIST</mark>
              </p>
              <h1 className="exceptional">
                <mark className="expmrk" id="excid">
                  {" "}
                  Exceptional care{" "}
                </mark>
              </h1>
              <h1 className="exceptional">
                <mark className="expmrk" id="excid">
                  {" "}
                  for all ages{" "}
                </mark>
              </h1>
              {/* <h1 className="exceptional"><mark className='expmrk'></mark></h1> */}
              <a href="/booknow">
                <button className="book-button">BOOK ONLINE</button>
              </a>
              <pre className="call-text">
                OR CALL <a href="tel:+918882672980">088826 72980</a>
              </pre>
              {/* <p className="call-text">9582474046</p> */}
            </div>
          </div>
        </div>
        <div className="home-sec2">
          <div className="home-sec2-box">
            <div className="home-sec2-content">
              <h1 className="Dentist">Dentistry Done Right</h1>
              <div className="adultspara">
                <p className="adults">
                  At Bombay Dental Company, we are dedicated to providing
                  exceptional dental care by harnessing the power of the latest
                  technology.
                </p>
                <p className="adults">
                  {isSmallScreen && showMore && (
                    <>
                      {" "}
                      Our advanced tools and techniques, including digital
                      X-rays, digital scanning impressions, and B-Class fully
                      digitized autoclaves for 100% sterilization, are designed
                      to elevate your dental experience. Adults and kids, we
                      welcome patients from 3-year-olds to seniors! Our team is
                      passionate about building lifetime relationships through
                      positive experiences.
                    </>
                  )}
                  {/* On large screens, always show the full content */}
                  {!isSmallScreen && (
                    <>
                      {" "}
                      Adults and kids, we welcome patients from 3-year-olds to
                      seniors! Our team is passionate about building lifetime
                      relationships through positive experiences.
                    </>
                  )}
                </p>
                {isSmallScreen && (
                  <button
                    className="read-more-btn"
                    onClick={handleReadMoreClick}
                  >
                    {showMore ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
              <ul
                className="tickp"
                style={{
                  marginLeft: "7.5%",
                }}
              >
                <li className="list">Affordable and transparent pricing </li>
                <li className="list">
                  Flexible appointment timings including Sunday{" "}
                </li>
                <li className="list">
                  No wait policy on pre-booked appointments
                </li>
              </ul>
            </div>
            <div className="home-sec2-img">
              <img
                src={sec}
                alt="Dental Care"
                style={{
                  width: "90%",

                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>

        <div className="home-sec3">
          <div className="testimonials-container">
            <div className="home-sec3-header">
              <h2 className="kind">Kind words from our patients</h2>
              <p>
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon
                    key={i}
                    icon={faStar}
                    className="star-icon"
                  />
                ))}
              </p>
              <p>1,200+ 5-star reviews!</p>
            </div>
            <div className="quote-card">
              <div className="quote-profile">
                <img src={image} alt="Profile" className="profile-img" />
              </div>
              <div className="content-main">
                <div className="quote-content">
                  <p className="quote-text">"{text}"</p>
                  <hr></hr>
                  <div className="quote-author">
                    <span className="author-role">{role}</span>
                    <span className="author-name">{author}</span>
                  </div>
                </div>
              </div>
              <div className="quote-navigation">
                <button onClick={prevQuote} className="nav-button">
                  &#8592;
                </button>
                <button onClick={nextQuote} className="nav-button">
                  &#8594;
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="home-sec4">
          <div className="services-section">
            {/* <h2 className="kind">SECTION4</h2> */}
            <h2 className="services-title">
              Comprehensive care, one convenient location
            </h2>
            <div className="services-cards">
              {services.map((service, index) => (
                <div key={index} className="service-card">
                  <img
                    src={service.imgSrc}
                    alt={service.title}
                    className="service-image"
                  />
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <a href={service.link}>
                    <button className="service-button">
                      {service.buttonText}
                    </button>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="home-sec6">
          <div className="insurance0"></div>

          <div className="transparent-pricing">
            <h3>TRANSPARENT PRICING</h3>
            <h1>No Surprises</h1>
            <p>
              Our team believes in accessible dental care. We offer
              straightforward pricing, clear estimates, and an unprecedented
              dental warranty. Keep up with your routine 6-month checkups and if
              something needs fixing, we’ll handle it at no cost to you.
            </p>
          </div>
        </div>
        {/* Section: Dental Bar Menu */}
        <div
          className="dental-bar-menu"
          style={{ margin: " 0 0px", backgroundColor: "white" }}
        >
          <h2
            className="menu-title"
            style={{ textAlign: "center", color: " black", width: "95%" }}
          >
            Bombay Dental Company Menu
          </h2>
          <Slider {...sliderSettings}>
            {barItems.map((item, index) => (
              <div
                key={index}
                className="menu-item"
                style={{ textAlign: "center", height: "100%" }}
              >
                <div
                  className="icon"
                  style={{ marginBottom: "10px", color: " #0047AB" }}
                >
                  {item.icon}
                </div>
                <p className="label" style={{ color: " #0047AB" }}>
                  {item.label}
                </p>
              </div>
            ))}
          </Slider>
        </div>

        <div className="visit-us-container">
          <div className="images-container">
            <img src={dental1} alt="Waiting Area" className="image-item" />
            <img src={dental2} alt="Exam Room" className="image-item" />
            <img src={dental3} alt="Sign" className="image-item" />
            <img src={dental4} alt="Lounge" className="image-item" />
          </div>
          <div className="info-container">
            <h1 className="visit">Visit Us</h1>
            <p className="weare">
              We are conveniently located right on the Worli Naka, on the first
              floor of Atur House, opposite the Bharat Petroleum Pump. Our
              guards are very helpful, and free parking is provided easily upon
              asking.
            </p>
            <div className="lhflex">
              <div className="location">
                <h1 className="tp">
                  <IoLocationOutline />
                </h1>
                <p>
                  {" "}
                  Bombay Dental Company
                  <br />
                  Atur House
                  <br />
                  First Floor, Flat no 2<br />
                  Worli Naka, Worli
                  <br />
                  Mumbai 400018
                </p>
                <a
                  href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                  className="directions-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Directions
                </a>
              </div>
              <div className="hours">
                <h1 className="tp">
                  <IoTimeOutline />
                </h1>
                <p>
                  {" "}
                  Mon-Sat 9 am – 7 pm
                  <br />
                  Sun 10 am – 2 pm
                  <br />
                  Thursday off
                </p>
              </div>
            </div>
          </div>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
              width="100%"
              height="450"
              style={{ border: "8px", borderRadius: "18px " }}
              allowFullScreen
              loading="lazy"
              title="Google Maps Location of Bombay Dental Company"
            />
          </div>
        </div>
        <div className="home-sec8">
          <div className="book-visit-container">
            <div className="online">
              <h1 className="book">Book your visit online</h1>
              <p className="view">
                Book your visit online and enjoy our unique No-wait policy, so
                that you have time for what you enjoy, and not spend your
                precious time in the doctor’s waiting area. A few lucky callers
                every month will be randomly shortlisted for a free scaling and
                polishing session.
              </p>
              <a href="/booknow">
                <button className="book-button1">BOOK ONLINE</button>
              </a>
              <div className="grayimg"></div>
            </div>
          </div>
        </div>
      </div>
      <a
        href={whatsAppLink}
        id="whatsapp-logo"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa-brands fa-whatsapp"></i>
      </a>
    </>
  );
}
export default Home;